import { useMemo } from 'react'
import PageTemplateData from '@v4/utils/data/PageTemplateData'
import OuterContainer from '../OuterContainer'
import MainContainer from '../MainContainer'
import BaseContainer from '../BaseContainer'

export const useContainer = ({ collection, className, relatedSections, children }) => {
	const Element = useMemo(() => {
		switch (collection) {
			case PageTemplateData.SORT_GROUPS.HEADER:
			case PageTemplateData.SORT_GROUPS.FOOTER:
				return OuterContainer
			case PageTemplateData.SORT_GROUPS.MAIN:
				return MainContainer
			default:
				return BaseContainer
		}
	}, [collection])

	return [
		{
			Element,
			collection,
			className,
			relatedSections,
			children,
		},
	]
}
